import React from "react";
import { FaBullseye } from "react-icons/fa";

const DartLogo = () => <FaBullseye color="black" size={"40px"} />;

export default DartLogo;